import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';

import {
	getIsLockingFormOpenSelector,
	getActiveLockingIdSelector,
	getCylindersTypesSelector
} from '../../reducers/app';

import { getLockingForm } from '../../reducers/app/lockingForm';
import {
	getActiveLockingId,
	doToggleActiveLockingId
} from '../../reducers/app/activeLockingId';

import {
	getLockings,
	lockingsSelector,
	getRootLockingSelector,
	getGroupsSelector
} from '../../reducers/lockings';

import {
	saveLockingRequest,
	deleteLockingRequest,
	cloneLockingRequest,
	closeLockingForm
} from './lockingsActions';

import LockingForm from './LockingForm';
import DeleteModal from './DeleteModal';
import DuplicateModal from './DuplicateModal';

import Icon from '../../common/components/Icon';

const initialState = {
	name: '',
	parent_locking_id: 0,
	cylinder_type_id: 1,
	disengageable: false,
	dimension_a: 30,
	dimension_b: 30,
	isDeleteModalOpen: false,
	isDuplicateModalOpen: false,
	iterations: 1
};

class LockingFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState
		};
		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleInGroupChange = this.handleInGroupChange.bind(this);
		this.handleCylinderTypeChange = this.handleCylinderTypeChange.bind(
			this
		);
		this.handleDisengageableChange = this.handleDisengageableChange.bind(
			this
		);
		this.handleDimensionAChange = this.handleDimensionAChange.bind(this);
		this.handleDimensionBChange = this.handleDimensionBChange.bind(this);
		this.handleDimensionBlur = this.handleDimensionBlur.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.getCylinderDimensions = this.getCylinderDimensions.bind(this);
		this.onIterationChange = this.onIterationChange.bind(this);
		this.openDeleteModal = this.openDeleteModal.bind(this);
		this.closeDeleteModal = this.closeDeleteModal.bind(this);
		this.openDuplicateModal = this.openDuplicateModal.bind(this);
		this.closeDuplicateModal = this.closeDuplicateModal.bind(this);
		this.resetForm = this.resetForm.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		/* Fix #2492 */
		if (!this.state.parent_locking_id) {
			const rootId = nextProps.root.locking_id;
			this.setState({
				parent_locking_id: rootId
			});
		}

		const nextLocking = nextProps.locking;
		const isSameLocking =
			nextLocking.locking_id === this.props.locking.locking_id;

		if (isSameLocking) {
			return;
		}

		const isNewLocking = !nextLocking.locking_id;
		if (isNewLocking) {
			this.setState({
				...initialState,
				parent_locking_id: this.props.root.locking_id
			});
			return;
		}

		this.setState({
			name: nextLocking.name,
			parent_locking_id: nextLocking.parent_locking_id,
			cylinder_type_id: nextLocking.cylinder_type_id,
			disengageable: nextLocking.disengageable,
			dimension_a: nextLocking.dimension_a,
			dimension_b: nextLocking.dimension_b
		});
	}

	render() {
		if (!this.props.isOpen) return null;

		const classes = classNames({
			'c-locking-form-container': true,
			'is-open': this.props.isOpen
		});

		const wrapperClasses = classNames({
			'u-flex': true,
			'c-locking-form-wrapper': true
		});

		const { cylinder_type_id } = this.state;
		const cylinderDimensions = this.getCylinderDimensions(cylinder_type_id);
		const canDelete =
			this.props.locking.locking_id &&
			this.props.locking.rgt - this.props.locking.lft === 1;
		return (
			<div className={wrapperClasses}>
				<div className="c-locking-form-container">
					<LockingForm
						lockingId={this.props.locking.locking_id}
						canDelete={canDelete}
						name={this.state.name}
						onNameChange={this.handleNameChange}
						isLocking={this.props.isLocking}
						inGroupOptions={this.props.inGroupOptions}
						parentLockingId={this.state.parent_locking_id}
						onInGroupChange={this.handleInGroupChange}
						cylinder_type_id={this.state.cylinder_type_id}
						onCylinderTypeChange={this.handleCylinderTypeChange}
						disengageable={this.state.disengageable}
						onDisengageableChange={this.handleDisengageableChange}
						cylinderDimensions={cylinderDimensions}
						dimensionA={this.state.dimension_a}
						onDimensionAChange={this.handleDimensionAChange}
						dimensionB={this.state.dimension_b}
						onDimensionBChange={this.handleDimensionBChange}
						onDimensionBlur={this.handleDimensionBlur}
						onDelete={this.openDeleteModal}
						onDuplicate={this.openDuplicateModal}
						onSubmit={this.handleSubmit}
					/>

					<DeleteModal
						isOpen={this.state.isDeleteModalOpen}
						locking={this.props.locking}
						onDelete={this.props.deleteLockingRequest.bind(
							null,
							this.props.locking.locking_id
						)}
						onClose={this.closeDeleteModal}
					/>

					<DuplicateModal
						isOpen={this.state.isDuplicateModalOpen}
						locking={this.props.locking}
						iterations={this.state.iterations}
						onChange={this.onIterationChange}
						onSubmit={this.props.closeLockingRequest.bind(
							null,
							this.props.locking.locking_id,
							this.state.iterations
						)}
						onClose={this.closeDuplicateModal}
					/>
				</div>

				<div
					className="mask u-flex-1"
					onClick={this.props.closeLockingForm}
				>
					<button className="m-1 u-cursor-pointer">
						<Icon icon="cancel" size="large" color="white" />
					</button>
				</div>

			</div>
		);
	}

	handleNameChange(value) {
		this.setState({ name: value });
	}

	handleInGroupChange(parent_locking_id) {
		this.setState({ parent_locking_id });
	}

	handleCylinderTypeChange(cylinderTypeId) {
		const {
			disengageable,
			cylinder_type_id,
			dimension_a,
			dimension_b
		} = this.state;

		const nextDimensions = this.getCylinderDimensions(cylinderTypeId);

		this.setState({
			cylinder_type_id: cylinderTypeId,
			disengageable: cylinderTypeId === 3 ? false : disengageable,
			dimension_a: this.adjustDim(
				dimension_a,
				nextDimensions.dimension_a.min,
				nextDimensions.dimension_a.max
			),
			dimension_b: this.adjustDim(
				dimension_b,
				nextDimensions.dimension_b.min,
				nextDimensions.dimension_b.max
			)
		});
	}

	handleDisengageableChange(event) {
		const disengageable = event.target.checked;
		this.setState({ disengageable });
	}

	handleDimensionAChange(event) {
		const dimension_a = Math.abs(event.target.value);
		this.setState({ dimension_a });
	}

	handleDimensionBChange(event) {
		const dimension_b = event.target.value;
		this.setState({ dimension_b });
	}

	handleDimensionBlur(min, max, dimension, event) {
		const value = event.target.value;

		// Nearest multiple of 5
		let ajustedValue = Math.ceil(value / 5) * 5;

		if (ajustedValue < min) {
			ajustedValue = Number(min);
		}

		if (ajustedValue > max) {
			ajustedValue = Number(max);
		}

		if (dimension === 'dimension_a') {
			this.setState({ dimension_a: ajustedValue });
		}

		if (dimension === 'dimension_b') {
			this.setState({ dimension_b: ajustedValue });
		}
	}

	handleSubmit() {
		this.props
			.saveLockingRequest(
				this.state,
				this.props.lockingId,
				this.props.isLocking,
				this.props.root
			)
			.then(() => {
				this.props.closeLockingForm();
				this.resetForm();
			});
	}

	getCylinderDimensions(cylinderTypeId) {
		const { disengageable } = this.state;

		const cylindersCodesById = {
			1: 'DE',
			2: 'BT',
			3: '1/2'
		};

		let cylinderCode = cylindersCodesById[cylinderTypeId];

		if (disengageable && cylinderCode !== '1/2') {
			cylinderCode = `${cylinderCode}+D`;
		}

		const cylinderDimensions = this.props.cylindersTypes[cylinderCode];
		return cylinderDimensions;
	}

	adjustDim(dim, min, max) {
		const isToSmall = Number(dim) < Number(min);
		if (isToSmall) {
			return min;
		}

		const isToBig = Number(dim) > Number(max);
		if (isToBig) {
			return max;
		}

		return dim;
	}

	onIterationChange(value) {
		this.setState({ iterations: value });
	}

	openDeleteModal() {
		this.setState({ isDeleteModalOpen: true });
	}

	closeDeleteModal() {
		this.setState({ isDeleteModalOpen: false });
	}

	openDuplicateModal() {
		this.setState({ isDuplicateModalOpen: true });
	}

	closeDuplicateModal() {
		this.setState({ isDuplicateModalOpen: false });
	}

	resetForm() {
		this.setState({ ...initialState });
	}
}

function mapStateToProps(state) {
	const lockingsByIds = lockingsSelector(state);
	const lockingId = getActiveLockingId(state);
	const groupsIds = getGroupsSelector(state);
	const rootLocking = getRootLockingSelector(state);
	const inGroupOptions = groupsIds.map(groupId => {
		return {
			text: lockingsByIds[groupId].name,
			value: lockingsByIds[groupId].locking_id
		};
	});

	inGroupOptions.unshift({
		text: `${rootLocking.name} (aucun groupe)`,
		value: rootLocking.locking_id,
		isRoot: true
	});

	const active = lockingsByIds[lockingId] || {};

	const lockingForm = getLockingForm(state);

	const locking = lockingsByIds[lockingId] || {};

	const parentLocking = getParentLocking(locking, getLockings(state)) || {};
	locking.parent_locking_id = parentLocking.locking_id;

	return {
		isOpen: lockingForm.isOpen,
		isLocking: lockingForm.formMode === 'LOCKING' ? true : false,
		root: rootLocking,
		lockingId,
		locking,
		cylindersTypes: getCylindersTypesSelector(state),
		inGroupOptions
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		closeLockingForm: () => {
			dispatch(closeLockingForm());
			dispatch(doToggleActiveLockingId());
		},
		saveLockingRequest: (fields, lockingId, isLocking, rootId) => {
			return dispatch(
				saveLockingRequest(
					projectId,
					fields,
					lockingId,
					isLocking,
					rootId
				)
			);
		},
		deleteLockingRequest: lockingId => {
			dispatch(deleteLockingRequest(projectId, lockingId));
		},
		closeLockingRequest: (lockingId, iterations) => {
			dispatch(cloneLockingRequest(projectId, lockingId, iterations));
		}
	};
}

function getParentLocking(locking, lockings) {
	const parentLockings = lockings.filter(locking2 => {
		if (locking2.lft < locking.lft && locking2.rgt > locking.rgt)
			return true;
	});

	const firstParent = parentLockings[parentLockings.length - 1];

	return firstParent;
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(LockingFormContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/LockingFormContainer.js